import React, { useEffect } from 'react';
import { useServeFileById } from '@/hooks/upload/use-file';
import { Question } from '@/types';
import { useFormResponseStore } from '@/store';

interface AddImageProps {
  question: Question;
  sectionId: string;
  sectionName: string;
}

export const AddImageAnswer: React.FC<AddImageProps> = ({ question, sectionId, sectionName }) => {
  const { setResponse } = useFormResponseStore();
  const { 
    data: imageUrl, 
    isLoading, 
    error 
  } = useServeFileById(question.image || '');

  useEffect(() => {
    if (question.image) {
      setResponse(
        sectionId,
        sectionName,
        question.id,
        question.type,
        question.label || '',
        {
          image: question.image
        }
      );
    }
  }, [question.id, question.type, question.label, question.image, sectionId, sectionName, setResponse]);

  if (isLoading) {
    return <div className="max-h-[320px] bg-gray-200 flex items-center justify-center">Loading...</div>;
  }

  if (error || !imageUrl) {
    return <div className="max-h-[320px] bg-gray-200 flex items-center justify-center text-gray-500">Failed to load image</div>;
  }

  return <img src={imageUrl} alt="Uploaded" className="max-h-[320px] object-cover" />;
};
